import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { editBulkLoadList } from "../../actions/equipment-group";
import { useLoadHistoryContext } from "./context/LoadHistoryContext";
import { Modal } from "../widgets";
import { ScreenOverlayLoader } from "../widgets/ScreenOverlay";
import { Unit } from "../../helpers/unit";

const LoadBulkEditButton = ({ postSaveAction, farmId }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [showConfirmModal, setShowModal] = useState(false);
  const [isValidNetWeight, setValidNetWeight] = useState(true);

  const {
    selectedCrew,
    selectedField,
    selectedOffload,
    selectedStorage,
    loadWeight,
    bulkEditLoadList,
    resetBulkEdit,
    enableBulkEdit,
    selectedLoadLength,
    setLoadHistoryBulkEditStatus,
    showDeletedLoads,
    loadTareWeight,
    loadLightWeight,
    loadGrossWeight,
  } = useLoadHistoryContext();
  const disabled =
    (!selectedCrew &&
      !selectedField &&
      !selectedOffload &&
      !selectedStorage &&
      !loadTareWeight &&
      !loadLightWeight &&
      !loadGrossWeight &&
      !loadWeight) ||
    bulkEditLoadList.length === 0;

  const unit = Unit.getInstance();
  const dispatch = useDispatch();

  const handleBulkSave = () => {
    setShowModal(false);
    if (disabled) return;

    let hasInvalidLoad = [];
    let loadList = bulkEditLoadList.map((item) => {
      const netWeight = item.load_capacity
        ? unit.fromWeight(item.load_capacity)
        : 0;
      if (!(netWeight > 0)) hasInvalidLoad.push(item);

      return {
        ...item,
        pipe: item.pipeId ? item.pipeId : null,
        load_capacity: netWeight,
        tare_weight: item.tare_weight ? unit.fromWeight(item.tare_weight) : 0,
        light_weight: item.light_weight
          ? unit.fromWeight(item.light_weight)
          : 0,
        load_gross_weight: item.load_gross_weight
          ? unit.fromWeight(item.load_gross_weight)
          : 0,
      };
    });

    const params = {
      farm_uuid: farmId,
      loads: loadList,
    };

    if (hasInvalidLoad.length > 0) {
      setValidNetWeight(false);
      return;
    } else setValidNetWeight(true);
    setIsSaving(true);

    dispatch(
      editBulkLoadList(params, () => {
        resetBulkEdit();
        const loadList = params.loads.map((item) => {
          return {
            ...item,
            pipe: item.pipeId ? `Pipe ${item.pipeId}` : null,
          };
        });
        postSaveAction(loadList);
        setIsSaving(false);
        setLoadHistoryBulkEditStatus(false);
      })
    );
  };

  const handleDiscard = () => {
    setValidNetWeight(true);
    setLoadHistoryBulkEditStatus(false);
    resetBulkEdit(false);
  };

  return (
    <>
      <div className="load-history-warning">
        {selectedLoadLength > 50 ? (
          <span className="text-danger">
            * Only a maximum of 50 loads are allowed for edits.
          </span>
        ) : !isValidNetWeight ? (
          <span className="text-danger">* Net Weight can not be 0</span>
        ) : (
          <></>
        )}
        {enableBulkEdit ? (
          <div className="bulk-edit-btn-group">
            <Button
              size="sm"
              variant="primary"
              disabled={disabled}
              className="bulk-edit-save"
              onClick={() => setShowModal(true)}
            >
              <i className="fa fa-floppy-o mr-1"></i>
              {isSaving ? "Saving..." : "Save"}
            </Button>
            <Button
              size="sm"
              variant="danger"
              className="bulk-edit-discard"
              onClick={handleDiscard}
            >
              <i className="fa fa-times-circle mr-1" />
              Discard
            </Button>
          </div>
        ) : !showDeletedLoads ? (
          <Button
            size="sm"
            variant="warning"
            className="bulk-edit-btn"
            onClick={() => setLoadHistoryBulkEditStatus(true)}
          >
            <i className="fa fa-pencil-square-o mr-1" aria-hidden="true" />
            Bulk Edit
          </Button>
        ) : null}
      </div>

      <ScreenOverlayLoader show={isSaving} />

      <Modal.Confirm
        className="modal-bordered"
        show={showConfirmModal}
        onConfirm={handleBulkSave}
        onHide={() => setShowModal(false)}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        content={`Are you sure to bulk update the ${bulkEditLoadList.length} loads?`}
        variant="info"
        confirmButton={{ variant: "info" }}
      />
    </>
  );
};

export default LoadBulkEditButton;